import { Component } from '@angular/core';
import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastNotificationService } from '../../../core/toast-notification.service';
import { UIBlockingService } from '../../../core/ui-blocking.service';
import { MemberUserManagementService } from '../../member-user-management/member-user-management.service';
import { DumbLiaison } from '../DTOs/dumb-liaison';
import { MembershipManagementService } from '../membership-management.service';

@Component({
  selector: 'app-edit-member-company-liaison',
  templateUrl: './edit-company-liaison.component.html',
  providers: [UIBlockingService]
})
export class EditCompanyLiaisonModalComponent {

  constructor(private activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private membershipService: MembershipManagementService,
    private notificationService: ToastNotificationService,
    private blockUI: UIBlockingService) { }


  liaison: DumbLiaison;

  firstNameCtrl = new FormControl("firstName", [Validators.required]);
  lastNameCtrl = new FormControl("lastName", [Validators.required]);
  emailAddressCtrl = new FormControl("emailAddress", [Validators.required, Validators.email]);
  phoneNumberCtrl = new FormControl("phoneNumber", [Validators.required]);
  jobTitleCtrl = new FormControl("jobTitle");

  manageLiaisonForm: FormGroup = new FormGroup({
    firstName: this.firstNameCtrl,
    lastName: this.lastNameCtrl,
    emailAddress: this.emailAddressCtrl,
    phoneNumber: this.phoneNumberCtrl,
    jobTitle: this.jobTitleCtrl
  });

  firstName() { return this.manageLiaisonForm.get('firstName').value }
  lastName() { return this.manageLiaisonForm.get('lastName').value }
  email() { return this.manageLiaisonForm.get('emailAddress').value }
  phoneNumber() { return this.manageLiaisonForm.get('phoneNumber').value }
  jobTitle() { return this.manageLiaisonForm.get('jobTitle').value }

  ngOnInit() {
    this.resetmanageLiaisonForm();
  }

  private resetmanageLiaisonForm(): void {
    this.manageLiaisonForm.reset();
    this.manageLiaisonForm.patchValue({
      firstName: this.liaison.firstName,
      lastName: this.liaison.lastName,
      emailAddress: this.liaison.emailAddress,
      phoneNumber: this.liaison.phoneNumber,
      jobTitle: this.liaison.jobTitle
    });
  }

  saveLiaison() {

    for (var i in this.manageLiaisonForm.controls) {
      this.manageLiaisonForm.controls[i].markAsTouched();
    }
    if (!this.manageLiaisonForm.valid) {
      return false;
    }

    this.liaison.firstName = this.firstName();
    this.liaison.lastName = this.lastName();
    this.liaison.emailAddress = this.email();
    this.liaison.phoneNumber = this.phoneNumber();
    this.liaison.jobTitle = this.jobTitle();

    this.blockUI.start();
    this.membershipService.UpdateCompanyLiaison(this.liaison)
      .subscribe({
        next: (data) => {
            this.blockUI.stop();
            this.activeModal.close(data);
        },
        error: (err) => {
          console.log(err)
          this.notificationService.error(err.error.message);
          this.blockUI.stop();
        },
      });
      return true;

  }

  dismiss(): void {
    this.activeModal.dismiss();
  }


}
